export default {
    company:"선전시 쓰보 전자 유한회사",
    router: {
       homePage:"홈 페이지",
       news:"기업 뉴스",
       product:"제품 전시",
       cooperation:"브랜드",
       contact:"연락처",
       about:"우리에 대해"
     },
     home:{
      placeholder:"제품을 입력하십시오",
      news:"뉴스 동태",
      companyTitle:"우리에 대해",
      honors:"회사 명예",
      classification:"분류",
      NewsList:"뉴스 리스트",
      prodDetails:"제품 정보",

      city:"선전",
      add:'심수시 복전구 중항로 정성국제빌딩 817',
      tel:'전화',
      fax:"팩스",
      contact:"대화 상대：차이훙창 13723766003",
      email:"메일"

    },
    detailList:{
      image:"사진",
      name:"이름",
      classifiy:"류별",
      details:'설명'
    },
    intoduction:{
      Number:"물품:",
      Specif:"규격:",
      Category:"류별:",
      Hotline:"자문핫라인:",
  
      detail:"설명",
      Related:"관련 상품",
  
      order:"구매:",
      name:"대화 상대:",
      phone:"전화:",
      email:'메일 박스:',
      description:"우리가 통일적으로 물품을 준비할 수 있도록 주문상품의 수량과 상품설명을 기입해 주십시오.",
      submit:"제출",
    },
    footer:{
      Copyright:"선전시 쓰보 전자 유한회사 판권 소유",
      add:"주소：심수시 복전구 중항로 정성국제빌딩 817",
      tel:"전화：0755-82543095",
      icp:"ICP 등록 번호：粤ICP备14010311号-1",
      it:"기술 지원：세븐스 시티"
    }
   
   }